module.exports = __webpack_public_path__ + "img/search-black-icon.6d7c9b37.svg";